import { Shape } from './Shape';
import { TeaBlocksError } from './../../TeaBlocksError';
import { ReturnBlock } from "../ReturnBlock";

/**
 * Gets the x position of a shape
 */
export class GetXBlock extends ReturnBlock {
    shape: ReturnBlock

    /**
     * Constructor
     * @param id the id
     * @param inputs inputs[0] is the get shape.
     */
    constructor(id: string, inputs: ReturnBlock[]) {
        super(id);
        this.shape = inputs[0];
    }

    /**
     * Returns x position.
     * @param varEnv variable environment
     */
    evalBlock(varEnv: Map<string, any>){
        let shapeName = this.shape.evalBlock(varEnv);

        let shape: Shape = varEnv.get(shapeName);
        
        if(!shape) throw new TeaBlocksError('This shape does not exist', this.id);

        return shape.posX;
    }
}